import React, { useContext, useEffect, useState } from "react";
import { Select } from "@chakra-ui/react";
import { useMutation } from "react-query";
import { useToast } from '@chakra-ui/react'
import { useNavigate } from "react-router-dom";
import { AdminContext } from "../../contexts/AdminContext";
import { updateOrderStatus } from "../../services/orders";

type Props = {
  options: {
    label: string;
    value: string;
    id: number;
  }[];
  order_id: string
}

export default function ProcessOrder({ options, order_id }: Props) {
  const toast = useToast()
  const navigate = useNavigate();
  const { admin } = useContext(AdminContext)
  const token = `bearer ${admin.token}`

  const [action, setAction] = useState('')

  useEffect(() => {
    if (action) {
      processOrder.mutate({ status: action })
    }
  }, [action])

  const processOrder = useMutation((data: any) => updateOrderStatus(token, data, order_id), {
    onError: () => {
      toast({
        title: "Error updating order. Try again",
        status: 'error',
        isClosable: true,
        duration: 2000
      })

      setAction('')
    },

    onSuccess: () => {
      toast({
        title: "Order status updated",
        status: 'success',
        isClosable: true,
        duration: 2000
      })

      setTimeout(() => {
        navigate("/orders");
      }, 2000)
    }
  })

  useEffect(() => {
    if (processOrder.isLoading){
      toast({
        title: "Processing, please wait...",
        status: 'loading',
        isClosable: false,
      })
    }
  }, [processOrder.isLoading])

  return (
    <Select
      placeholder='Action'
      color='gray.500'
      border='1px'
      borderColor='gray.500'
      focusBorderColor='#37A75B'
      value={action}
      // defaultValue={action}
      onChange={({ target }) => {
        setAction(target.value)
      }}
    >
      {options.map((option: {
        label: string;
        value: string;
        id: number
      }) => (
        <option
          key={option.id}
          value={option.value}
        >
          {option.label}
        </option>
      ))}
    </Select>
  )
}